<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 智慧能源上 -->
      <el-row>
        <el-col :span="24" class="scene_top">
          <div class="scene_topContent">
            <h1>智慧能源</h1>
            <ul>
              <li>能耗数据可视化</li>
              <li>全面能源分析</li>
              <li>主动式节能</li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <!-- 业务痛点 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space scene_park">
            <div class="title">
              <h3>能效惑，成本不知所云</h3>
            </div>
            <el-row>
              <el-col :span="8">
                <div class="content content_leftContent">
                  <h4 style="margin-bottom: 13px !important">
                    被动防范，体验和使用效果差
                  </h4>
                  <p>缺乏针对性场景化方案，无法有效找准挖潜点和整改点</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content_picture content_pictureOne">
                  <img src="~@/assets/images/smartEnergy4.png" />
                </div>
              </el-col>
              <el-col :span="8">
                <el-row>
                  <div
                    class="content"
                    style="text-align: left; padding-left: 25%"
                  >
                    <h4 style="margin-bottom: 13px !important">
                      数据散，无法有效统计
                    </h4>
                    <p>传统企业能源监测不全面，数据不及时，信息不透明不互通</p>
                  </div>
                </el-row>
                <el-row>
                  <div
                    class="content"
                    style="text-align: left; padding-left: 25%"
                  >
                    <h4 style="margin-bottom: 13px !important">
                      故障忧，都在被动响应
                    </h4>
                    <p>无预警、预防、预测机制，跑冒滴漏浪费现象发现滞后</p>
                  </div>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 核心功能 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space core_functions">
            <div class="title">
              <h3>核心功能</h3>
            </div>
            <el-row>
              <el-col :span="8">
                <div class="content">
                  <div
                    class="
                      content_picture content_pictureTwo content_pictureThree
                    "
                  >
                    <img src="~@/assets/images/intelligentSecurity2.png" />
                  </div>
                  <h4>实时监控</h4>
                  <p>能源全方位可视化监控，掌握能源能耗最新数据，安全高效</p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <div class="content_picture content_pictureThree">
                    <img src="~@/assets/images/smartEnergy2.png" />
                  </div>
                  <h4>能效管理</h4>
                  <p>
                    通过能耗预测、用能时间建模、运行异常诊断让用户站在行业顶端视角，观察、分析、优化自有项目的能耗方案。
                  </p>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="content">
                  <div class="content_picture content_pictureThree">
                    <img src="~@/assets/images/smartEnergy3.png" />
                  </div>
                  <h4>能耗策略</h4>
                  <p>
                    领先的高分辨实测数据库预置智控策略、运行策略评估助力客户全面迎接”碳中和“时代
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  // 上
  .scene_top {
    background: url(~@/assets/images/smartEnergy1.png) no-repeat;
    background-size: 100% 100%;
    height: 475px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      position: absolute;
      top: 145px;
      left: 255px;
      text-align: left;
      h1 {
        padding-bottom: 43px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      ul {
        margin-left: 20px;
      }
      ul li {
        font-size: 18px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
        color: #ffffff;
        float: left;
        margin-right: 57px;
      }
    }
  }

  // 业务痛点
  .scene_park {
    // background: #fff !important;
    // padding: 60px 358px 23px 359px !important;

    background: #fff !important;
    padding: 60px 236px 23px 236px !important;
    .content {
      text-align: right;
    }
    p {
      width: auto !important;
    }
  }

  .core_functions {
    .title {
      h3 {
        margin-bottom: 50px !important;
      }
    }
    .content {
      p {
        text-align: left;
      }
    }
  }

  //核心功能
  .content_space {
    background: #fafafa;
    padding: 60px 74px 122px 74px;
    h3 {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 37px;
    }
    p {
      font-size: 16px;
      font-family: MicrosoftYaHeiLight;
      line-height: 32px;
      width: 208px;
      margin: auto;
    }
    .content {
      margin: auto;
      font-weight: 400;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #000000;
        margin: 43px 0 44px 0;
      }
    }
  }

  .content_pictureOne {
    img {
      max-width: 565px;
      max-height: 369px;
    }
  }

  .content_pictureTwo {
    margin-left: 20px;
  }

  .content_pictureThree {
    img {
      max-width: 246px !important;
      max-height: 221px !important;
    }
  }

  .content_leftContent {
    padding-right: 15%;
  }
}

@media only screen and (max-width: 1600px) {
  .main_content {
    .content_pictureOne {
      padding-left: 7%;
    }
    .content_leftContent {
      padding-right: 7%;
    }

    .content_space {
      background: #fafafa;
      padding: 0.3125rem 0.795rem 0.635417rem 0.795rem;
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  metaInfo: {
    title: "智慧能源-WIDEN桅灯智能",
    meta: [
      {
        name: "keyWords",
        content:
          "智慧能源,桅灯智能,WIDEN,上海桅灯智能科技有限公司,湖南桅灯智能科技有限公司",
      },
      {
        name: "description",
        content:
          "桅灯智能，专注公共空间智慧建筑领域的物联网、人工智能技术，用技术赋能公共空间，桅灯智能智慧能源实现对能源全方位可视化监控，掌握能源能耗最新数据，安全高效。",
      },
    ],
  },
  data() {
    return {
      tabIndex: "2-3",
    };
  },
  methods: {},
  computed: {},
};
</script>